import I18n from 'I18n';
import { getTopOfDateTimestamp } from 'flow-doctor-lib/utils/dateTimeUtils';
import { daysAgo, isDateInRange, isValid as isValidSimpleDate, now as simpleDateNow } from 'foundations-components/transitional/utils/SimpleDate';
export const MAX_LOG_EVENT_RETENTION_DAYS = 180;

// Obtain a moment instance containing the timestamp midnight of user's TZ exactly 180 days ago
export const getMinActionLogsRetentionMoment = () => {
  const currentTimestamp = I18n.moment().subtract(MAX_LOG_EVENT_RETENTION_DAYS, 'days').valueOf();
  return I18n.moment.userTz(getTopOfDateTimestamp(currentTimestamp, 'USER_TZ'));
};
export const getMinActionLogsRetentionSimpleDate = () => {
  return daysAgo(MAX_LOG_EVENT_RETENTION_DAYS, 'userTz');
};
export function isWithinActionLogRetentionPeriod(value) {
  if (isValidSimpleDate(value)) {
    return isDateInRange(value, getMinActionLogsRetentionSimpleDate(), simpleDateNow('userTz'));
  } else {
    return getMinActionLogsRetentionMoment().isBefore(value);
  }
}